import { ValidationErrorType } from 'hooks/useForm';

type ConfigItem = {
    placeId?: string;
    [key: string]: string | undefined;
};

type ErrorState = Record<string, ValidationErrorType>;

export const handleConfigFieldChange = <T extends ConfigItem>({
    field,
    value,
    id,
    currentData,
    setData,
    setErrorState,
    validateFn,
    errorPrefixes,
}: {
    field: string;
    value: string;
    id?: string;
    currentData: T[];
    setData: React.Dispatch<React.SetStateAction<T[]>>;
    errorState: ErrorState;
    setErrorState: React.Dispatch<React.SetStateAction<ErrorState>>;
    validateFn: (data: T[]) => ErrorState;
    errorPrefixes: string[];
}) => {
    const updatedData = id
        ? currentData.map((config) => (config.placeId === id ? { ...config, [field]: value } : config))
        : currentData.map((config) => ({ ...config, [field]: value }));

    const newErrors = validateFn(updatedData);

    setErrorState((errors) => ({
        ...Object.fromEntries(
            Object.entries(errors).filter(([key]) => !errorPrefixes.some((prefix) => key.startsWith(prefix))),
        ),
        ...newErrors,
    }));

    setData(updatedData);
};
